import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgxSpinnerComponent } from "ngx-spinner";
import { VersionBadgeComponent } from "./components/version-badge/version-badge.component";
import { AppVersionService } from "./services/app-version/app-version.service";

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterOutlet, RouterLink, NgxSpinnerComponent, VersionBadgeComponent]
})
export class AppComponent {
   title = 'pwa_sisdrinfa';
  loading = false;

   constructor(private cdr: ChangeDetectorRef, appVersion: AppVersionService) {
    appVersion.init();
  }

  setLoadingState(active: boolean) {
    this.loading = active;
    this.cdr.markForCheck(); // avisa a Angular que debe refrescar la vista
  }

}
